exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart[data-v-589b8971] {\n  width: 100%;\n}\n", ""]);

// exports
